/**
 * Full Page Scroll Effect for Home Page Sections
 * Handles scroll, touch, and keyboard navigation between sections
 */

class FullPageScroll {
  constructor() {
    this.stage = document.getElementById('scroll-stage');
    this.sections = Array.from(document.querySelectorAll('.scroll-section'));
    this.index = 0;
    this.isAnimating = false;
    
    if (!this.stage || this.sections.length === 0) {
      return; // Exit if elements don't exist
    }
    
    this.init();
  }
  
  init() {
    this.bindEvents();
    this.setTransform(0);
  }
  
  // Clamp helper function
  clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }
  
  // Move stage to specific index
  setTransform(i) {
    this.stage.style.transform = `translateY(-${i * 100}vh)`;
    this.index = this.clamp(i, 0, this.sections.length - 1);
    
    // Update active section for potential styling
    this.sections.forEach((section, idx) => {
      section.classList.toggle('active', idx === this.index);
    });
  }
  
  // Navigate to section with animation lock
  goto(i) {
    if (this.isAnimating) return;
    
    i = this.clamp(i, 0, this.sections.length - 1);
    if (i === this.index) return;
    
    this.isAnimating = true;
    this.setTransform(i);
    
    // Match CSS transition duration + buffer
    setTimeout(() => {
      this.isAnimating = false;
    }, 900);
  }
  
  bindEvents() {
    // Wheel/scroll support
    let wheelDebounce = 0;
    window.addEventListener('wheel', (e) => {
      if (this.isAnimating) return;
      
      const now = Date.now();
      if (now - wheelDebounce < 60) return;
      wheelDebounce = now;
      
      // Only handle vertical scrolling
      if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
      
      if (e.deltaY > 0) {
        this.goto(this.index + 1);
      } else if (e.deltaY < 0) {
        this.goto(this.index - 1);
      }
    }, { passive: true });
    
    // Keyboard support
    window.addEventListener('keydown', (e) => {
      if (this.isAnimating) return;
      
      if (['ArrowDown', 'PageDown'].includes(e.key)) {
        e.preventDefault();
        this.goto(this.index + 1);
      } else if (['ArrowUp', 'PageUp'].includes(e.key)) {
        e.preventDefault();
        this.goto(this.index - 1);
      } else if (e.key === 'Home') {
        e.preventDefault();
        this.goto(0);
      } else if (e.key === 'End') {
        e.preventDefault();
        this.goto(this.sections.length - 1);
      }
    });
    
    // Touch support
    let startY = null;
    let touchStartTime = 0;
    const minSwipeDistance = 30;
    
    window.addEventListener('touchstart', (e) => {
      if (e.touches.length > 1) return;
      startY = e.touches[0].clientY;
      touchStartTime = Date.now();
    }, { passive: true });
    
    window.addEventListener('touchend', (e) => {
      if (startY === null) return;
      
      const endY = e.changedTouches[0].clientY;
      const dy = startY - endY;
      const dt = Date.now() - touchStartTime;
      
      if ((Math.abs(dy) > minSwipeDistance && dt < 800) || Math.abs(dy) > 80) {
        if (dy > 0) {
          this.goto(this.index + 1);
        } else {
          this.goto(this.index - 1);
        }
      }
      
      startY = null;
    }, { passive: true });
    
    // Resize: maintain correct position
    window.addEventListener('resize', () => {
      this.setTransform(this.index);
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Only initialize on template-index (home page)
  if (document.body.classList.contains('template-index')) {
    new FullPageScroll();
  }
});


// start new code pdm
document.addEventListener("DOMContentLoaded", () => { 
  let scrollDelta = 0;
  const $topbar = $('.menu-top-bar');

  if ($topbar.length === 0) return;

  let isHidden = false;

  window.addEventListener("wheel", (e) => {
    scrollDelta += e.deltaY;

    // Scrolling down
    if (scrollDelta > 20 && !isHidden) {
      $topbar.stop(true, true).slideUp(300); // Hide with animation
      isHidden = true;
      scrollDelta = 0;
    }

    // Scrolling up
    if (scrollDelta < -20 && isHidden) {
      $topbar.stop(true, true).slideDown(300); // Show with animation
      isHidden = false;
      scrollDelta = 0;
    }
  });
});


